import { DatesHelpers } from "@core/helpers";
import { DATE_FORMAT_FULL } from "@core/constants";

export const IWalletLines = Object.freeze({
  id: "id",
  amount: "amount",
  comment: "comment",
  createdAt: "created_at",
  createdBy: "created_by",
  regularizedAt: "deleted_at",
  regularizedBy: "deleted_by",
  identifierId: "identifier_id",
  identifierType: "identifier_type",
  isRemovable: "is_removable",
  userId: "user_id",
  billingSessionId: "billing_session_id",
});

export class WalletLinesModel {
  constructor(data = {}) {
    this[IWalletLines.id] = data[IWalletLines.id];
    this[IWalletLines.identifierId] = data[IWalletLines.identifierId];
    this[IWalletLines.identifierType] = data[IWalletLines.identifierType];
    this[IWalletLines.amount] = data[IWalletLines.amount];
    this[IWalletLines.comment] = data[IWalletLines.comment];
    this[IWalletLines.createdAt] = data[IWalletLines.createdAt];
    this[IWalletLines.createdBy] = data[IWalletLines.createdBy];
    this[IWalletLines.regularizedAt] = data[IWalletLines.regularizedAt];
    this[IWalletLines.regularizedBy] = data[IWalletLines.regularizedBy];
    this[IWalletLines.isRemovable] = data[IWalletLines.isRemovable];
    this[IWalletLines.billingSessionId] = data[IWalletLines.billingSessionId];
    this[IWalletLines.userId] = data[IWalletLines.userId];
  }

  getId() {
    return this[IWalletLines.id];
  }

  getIdentifierId() {
    return this[IWalletLines.identifierId];
  }

  getType() {
    return this[IWalletLines.identifierType];
  }

  getAmount() {
    return this[IWalletLines.amount];
  }

  getComment() {
    return this[IWalletLines.comment];
  }

  getBillingSessionId() {
    return this[IWalletLines.billingSessionId] || null;
  }

  getCreationDate() {
    return DatesHelpers.getDayjs(this[IWalletLines.createdAt]);
  }

  getFormattedCreationDate(format = DATE_FORMAT_FULL) {
    return this.getCreationDate().format(format);
  }

  getCreator() {
    return `${this[IWalletLines.createdBy]}(${this.getUserId()})`;
  }

  getRegularizationDate() {
    return DatesHelpers.getDayjs(this[IWalletLines.regularizedAt]) || null;
  }

  getFormattedRegularizationDate(format = DATE_FORMAT_FULL) {
    return this.getRegularizationDate().format(format);
  }

  getRegularizationAuthor() {
    return this[IWalletLines.regularizedBy] || null;
  }

  getUserId() {
    return this[IWalletLines.userId];
  }

  isRemovable() {
    return this[IWalletLines.isRemovable];
  }

  isRegularized() {
    return this.getRegularizationDate() && this.getRegularizationAuthor();
  }
}
